import { apiClient } from '@/shared/api/client';

export type CspSyncStatus = 'added' | 'already_registered' | 'no_access' | 'failed';
export interface CspSyncResultRow { uen: string; name?: string; status: CspSyncStatus; cspCd?: string; error?: string }
export interface CspSyncCheckResult { total: number; registered: string[]; remaining: string[] }
export interface CspSyncImportResult {
  total: number; added: number; alreadyRegistered: number; noAccess: number; failed: number;
  results: CspSyncResultRow[];
}
// apiClient.get/post 는 응답 본문을 돌려줌(client.ts:585-596) → 본문 { success, data } 의 data 가 결과
const body = <T>(res: unknown): T => ((res as { data?: T })?.data ?? {}) as T;

export const cspSyncApi = {
  async check(uens: string[]) { return body<CspSyncCheckResult>(await apiClient.post('/cspsync/check', { uens })); },
  async import(sessionId: string, uens: string[]) {
    // 자동 재전송 끔 — apiClient 는 네트워크 오류 시 POST 도 다시 보냄(client.ts 재시도, config.__retryCount 로 셈).
    // import 는 1회용 Singpass 세션 + 시작 메일이 있어 재전송하면 메일 중복·만료 세션 재사용 → 한 번만 보냄.
    return body<CspSyncImportResult>(await apiClient.post('/cspsync/import', { sessionId, uens },
      { __retryCount: Number.MAX_SAFE_INTEGER } as any));
  },
};
